<template>
  <div>
    <section id="last-work" class="cr-section about-area section-padding-xlg bg-image-4" data-white-overlay="9.5">
      <div class="section fp-section" data-anchor="fifth-section">
          <div class="container">
            <div class="row justify-content-between" v-if="page" v-html="page.content">
              </div>
            </div>
          </div>
    </section>
  </div>
</template>

<script>
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  name: 'Page',
  components: {
  },
  data () {
    return {
      index: null,
      items: [],
      page: null,
      loaded: false
    }
  },
  mounted () {
    this.getGallery()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getGallery()
    })
  },
  methods: {
    getGallery () {
      this.axios.get(this.$host + 'page/' + this.$route.params.slug).then(resp => {
        this.page = resp.data.data
        this.loaded = true
      }).catch(() => {
        this.loaded = true
        this.$router.push('/404')
      })
    }
  }
}
</script>

<style scoped>

.flex-column {
  max-width: 33%;
  width: 33%;
}
@media screen and (max-width: 800px) {
  .flex-column {
    flex: 50%;
    max-width: 50%;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .flex-column {
    flex: 100%;
    max-width: 100%;
  }
}

.portfolio-item.portfolio-filter-graphic.portfolio-filter-design {
  margin: 4px !important;
}
.portfolio {
  margin: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/gallery/Page.vue